import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const ExternalLinkIconV1 = ({ size = 14, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 14L21 3" />
    <path d="M21 3h-6" />
    <path d="M21 3v6" />
    <path d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6" />
  </svg>
);

export default ExternalLinkIconV1;
